export default [
  {
    path: '/rentals',
    name: 'Rentals',
    component: () => import('@/views/Rental/Index.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Genel Bakış',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/monthly',
    name: 'RentalsMonthly',
    component: () => import('@/views/Rental/Monthly.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Aylık Kiralama',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/cumulatives',
    name: 'RentalsCumulatives',
    component: () => import('@/views/Rental/Cumulatives.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Çalışan Araçlar',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/brands',
    name: 'RentalsBrands',
    component: () => import('@/views/Rental/Brands.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Markalar',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/buy-cars',
    name: 'RentalsBuyCars',
    component: () => import('@/views/Rental/BuyCars.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Yeni Araç Alımları',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/rental',
    name: 'RentalsStocks',
    component: () => import('@/views/Rental/Stocks.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Stok Durumları',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
  {
    path: '/rentals/sales',
    name: 'RentalsSales',
    component: () => import('@/views/Rental/Sales.vue'),
    meta: {
      pageTitle: 'Filo Kiralama',
      breadcrumb: [
        {
          text: 'Dönen Araçlar',
          active: true,
        },
      ],
      resource: 'RP_RENTAL',
      action: 'read',
    },
  },
]
